import { render } from "./EditDescription.vue?vue&type=template&id=ef4a1248"
import script from "./EditDescription.vue?vue&type=script&lang=js"
export * from "./EditDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__